<template>
  <div id="adminExtras">
    <vue-headful title="Admin" lang="en" />
    <div class="b-cinzento p-20 m-b-20">
      <select class="form-control" style="max-width:45%;float:left;" v-model="estacao" @change="estacaoFN()">
        <option disabled>Station</option>
        <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
      </select>
      <select class="form-control" style="max-width:45%;float:right;" v-model="grupo" @change="estacaoFN()">
        <option disabled>Groups</option>
        <option :value="dt.groupID" v-for="(dt, index) in groups" :key="index">{{dt.group_Name}}</option>
      </select>
      <div class="clearfix"></div>
      <div style="padding-top: 15px">
        <div class="row p-l-20">
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4"><b>Request Extras available</b></div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
            From:
              <date-picker required v-model="dateFrom" @change="handleChangeDate()" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :disabled-date="notBeforeDate" :lang="langData" placeholder="Date from"></date-picker>
            </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
            To:
            <date-picker required v-model="dateTo" @change="estacaoFN()" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :disabled-date="notBeforeDate1" :lang="langData" placeholder="Date to"></date-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-langs" v-if="extras.length > 0 && resultado">
      <b-tabs content-class="mt-3">
        <b-tab @click="sel = dt" :title="dt" v-for="(dt, index) in linguas" :key="index" :active="sel === dt">

          <div class="form-group" style="margin-bottom:30px;" v-for="(dtt, index1) in extras" :key="index1">
            <label>{{dtt.extra}}</label>
            <input v-model="traducoes['extra-' + dtt.extraID + '-tit-' + sel]" type="text" class="form-control inputStyling" placeholder="Title">
            <input v-model="traducoes['extra-' + dtt.extraID + '-desc-' + sel]" type="text" class="form-control inputStyling" placeholder="Descripton">
            <textarea v-model="traducoes['extra-' + dtt.extraID + '-observations-' + sel]" class="form-control inputStyling" placeholder="Observations"></textarea>
            <input style="display:block;" type="file" class="form-control inputStyling" :value="f1[index]" @change.prevent.stop="onFileChange($event, 'extra-' + dtt.extraID + '-img-' + sel)">
            <input type="radio" :id="'fdsf-1-' + index1" v-model="traducoes['extra-' + dtt.extraID + '-show-' + sel]" value="1"> <label :for="'fdsf-1-' + index1">Show</label>
            <input style="margin-left:20px;" type="radio" :id="'fdsf-2-' + index1" v-model="traducoes['extra-' + dtt.extraID + '-show-' + sel]" value="0"> <label :for="'fdsf-2-' + index1">No Show</label>
            <div class="clearfix"></div>
            <img v-if="traducoes['extra-' + dtt.extraID + '-img-' + sel]" :src="'/images/' + traducoes['extra-' + dtt.extraID + '-img-' + sel]" class="m-h-100" style="max-width:100%" />
            <hr />
          </div>

          <div class="clearfix"></div>
          <button type="button" @click="submitTrad" class="btn btn-primary float-right m-t-10">UPDATE</button>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminExtras',
  data () {
    return {
      linguas: [],
      traducoes: {},
      sel: '',
      extras: [],
      f1: [],
      estacoes: [],
      estacao: '',
      resultado: false,
      groups: [],
      grupo: '',
      dateTo: new Date(),
      dateFrom: new Date(),
      lang: 'GB',
      langData: {}
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Car Extras')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.linguas = JSON.parse(this.$store.state.option.langs)
        this.lang = this.$store.state.lang
        this.langData = {
          days: [this.$store.state.option['sun-' + this.lang], this.$store.state.option['mon-' + this.lang], this.$store.state.option['tue-' + this.lang], this.$store.state.option['wed-' + this.lang], this.$store.state.option['thu-' + this.lang], this.$store.state.option['fri-' + this.lang], this.$store.state.option['sat-' + this.lang]],
          months: [this.$store.state.option['jan-' + this.lang], this.$store.state.option['fev-' + this.lang], this.$store.state.option['mar-' + this.lang], this.$store.state.option['apr-' + this.lang], this.$store.state.option['may-' + this.lang], this.$store.state.option['jun-' + this.lang], this.$store.state.option['jul-' + this.lang], this.$store.state.option['aug-' + this.lang], this.$store.state.option['sep-' + this.lang], this.$store.state.option['out-' + this.lang], this.$store.state.option['nov-' + this.lang], this.$store.state.option['dec-' + this.lang]]
        }
        this.traducoes = this.$store.state.option
        this.sel = this.linguas[0]
        this.axios.get('/cars').then((res) => {
          this.groups = res.data
          this.grupo = res.data[0].groupID
          this.axios.get('/stations/' + this.estacao).then((res) => {
            this.estacoes = res.data
            this.resultado = true
            if (res.data.length) {
              this.estacao = res.data[0].StationID
              this.SET_LOAD()
              this.SET_LOAD1(true)
              this.estacaoFN()
            } else {
              this.resultado = true
              this.SET_LOAD()
            }
          }, (er) => {
            this.SET_AVISO(er.response.data.error)
          })
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      } else {
        this._.delay(this.init, 100)
      }
    },
    estacaoFN () {
      let date1 = this.dateFrom.toISOString().split('T')[0]
      let date2 = this.dateTo.toISOString().split('T')[0]
      this.axios.get('/cars/extras/' + this.grupo + '?pickUp[Date]=' + date1 + '&pickUp[rentalStation]=' + this.estacao + '&dropOff[Date]=' + date2 + '&dropOff[rentalStation]=' + this.estacao).then((res) => {
        if (Array.isArray(this.extras = res.data)) {
          this.extras = res.data
          res.data.map(dtt => {
            this.extras.observations = this.traducoes['extra-' + dtt.extraID + '-observations-' + this.sel]
          })
        } else {
          this.SET_AVISO(res.data.error)
        }
        this.SET_LOAD1()
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    // traducoes
    submitTrad () {
      this.SET_LOAD1(true)
      this.axios.post('/options', this.traducoes).then((res) => {
        this.SET_LOAD1()
        this.SET_TOAST({ msg: 'Updated successfully' })
        this.SET_OPTIONS(res.data)
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    onFileChange (e, name) {
      this.SET_LOAD1(true)
      e.preventDefault()
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.f1 = ''
      let data = new window.FormData()
      data.append('image', files[0])
      this.axios.post('/multimedia', data).then((res) => {
        this.traducoes[name] = res.data.image
        this.resultado = false
        this.resultado = true
        this.SET_LOAD1()
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    notBeforeDate (date) {
      return new Date(date) < new Date().setDate(new Date().getDate() - 1)
    },
    notBeforeDate1 (date) {
      return new Date(date) < this.dateFrom
    },
    handleChangeDate () {
      let d = new Date()
      d.setDate(this.dateFrom.getDate())
      d.setDate(d.getDate() + 3)
      this.dateTo = new Date(d)
      this.estacaoFN()
    }
  }
}
</script>
<style>
  .inputStyling{
    margin-bottom: 0.5em;
  }
</style>
